import GestureIcon from '@mui/icons-material/Gesture';
import ImageIcon from '@mui/icons-material/Image';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import { Box, Divider, Grid, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import useWidth from '../../../../components/Hooks/useWidth';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { useSignatureContext } from '../contexts/signature.context';
import { SignatureTabs } from '../types';
import { getModalContentXPadding } from '../utils';
import DigitTabPanel from './DigitTabPanel';
import DrawTabPanel from './DrawTabPanel';
import TabPanelWrapper from './TabPanelWrapper';
import UploadTabPanel from './UploadTabPanel';

interface SignContractProps {
  orderId: string;
}

const SignatureTab = (
  text: string,
  Icon: React.ElementType,
  smallWidth: boolean,
  mobileWidth: boolean,
) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      flex: '1',
      maxWidth: '50vw',
    }}
  >
    <Icon style={{ marginRight: 7, fontSize: smallWidth ? 16 : undefined }} />
    <Typography variant={mobileWidth ? 'body2' : 'body1'}>{text}</Typography>
  </Box>
);

export const SignContract = ({ orderId }: SignContractProps) => {
  const { changeHasSignInput } = useSignatureContext();
  const [selectedTab, setSelectedTab] = useState<SignatureTabs>(SignatureTabs.DIGIT);
  const { translate } = useTranslation();
  const { smallWidth, mobileWidth } = useWidth();
  const px = getModalContentXPadding(smallWidth);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
      }}
    >
      <Grid container direction="column" wrap="nowrap" style={{ width: '100%', height: '100%' }}>
        <Grid style={{ width: '100%' }} size="auto">
          <Box
            sx={{
              pl: px,
            }}
          >
            <Tabs
              id="sign-contract-tabs"
              indicatorColor="primary"
              onChange={(_, value) => {
                changeHasSignInput(false);
                setSelectedTab(value);
              }}
              value={selectedTab}
              variant={mobileWidth ? 'fullWidth' : undefined}
            >
              <Tab
                label={SignatureTab(
                  translate(LangEnum.ORDER_CONTRACT_TAB_DIGID),
                  KeyboardIcon,
                  smallWidth,
                  mobileWidth,
                )}
                value={SignatureTabs.DIGIT}
                disableRipple
              />
              <Tab
                label={SignatureTab(
                  translate(LangEnum.ORDER_CONTRACT_TAB_DRAW),
                  GestureIcon,
                  smallWidth,
                  mobileWidth,
                )}
                value={SignatureTabs.DRAW}
                disableRipple
              />
              <Tab
                label={SignatureTab(
                  translate(LangEnum.ORDER_CONTRACT_TAB_IMAGE),
                  ImageIcon,
                  smallWidth,
                  mobileWidth,
                )}
                value={SignatureTabs.UPLOAD}
                disableRipple
              />
            </Tabs>
          </Box>
          <Divider />
        </Grid>
        <Grid style={{ width: '100%' }} size="grow">
          <Box
            sx={{
              px: px,
              height: '100%',
            }}
          >
            <TabPanelWrapper selected={selectedTab === SignatureTabs.DIGIT}>
              <DigitTabPanel orderId={orderId} />
            </TabPanelWrapper>
            <TabPanelWrapper selected={selectedTab === SignatureTabs.DRAW}>
              <DrawTabPanel orderId={orderId} />
            </TabPanelWrapper>
            <TabPanelWrapper selected={selectedTab === SignatureTabs.UPLOAD}>
              <UploadTabPanel orderId={orderId} />
            </TabPanelWrapper>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
